// extracted by mini-css-extract-plugin
export var container = "_3y-0";
export var icon = "_3y-1";
export var text = "_3y-2";